import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=63bf248a&"
import script from "./Advantages.vue?vue&type=script&lang=js&"
export * from "./Advantages.vue?vue&type=script&lang=js&"
import style0 from "./Advantages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports